"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadSpotWorkerSummaryKey = exports.handleSpotShiftChangeKey = exports.spotShiftStoreKey = exports.spotWorkerStoreKey = void 0;
exports.spotWorkerStoreKey = Symbol("spotWorkerStore");
exports.spotShiftStoreKey = Symbol("spotShiftStore");
exports.handleSpotShiftChangeKey = Symbol("handleSpotShiftChange");
exports.loadSpotWorkerSummaryKey = Symbol("loadSpotWorkerSummary");
